import { Component, OnInit } from '@angular/core';
import { Logo } from '../../interfaces/Logo';
import { ConfigService } from '../../services/config.service';

interface Cuerpo {
    fondoColor?: string;
    textoColor?: string;
    texto: string;
}
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
    cuerpo?: Cuerpo;
    logoDerecha?: Logo;
    height?: number;
    constructor(private configService: ConfigService) {}

    ngOnInit(): void {
        let { footer } = this.configService.config;
        this.cuerpo = footer.cuerpo;
        this.logoDerecha = footer.logoDerecha;
        this.height = footer.height;
    }
}
